import { choiceModal } from "~/lib/choiceModal";

import type { EventEditType } from "~/__generated__/MeetingsPanelAttendanceMutation.graphql";

export default async function recurrenceChoiceModal(
	hideThisOption = false,
	hideFollowingOption = false,
): Promise<EventEditType | null> {
	const choices: { value: EventEditType; label: string }[] = [
		...(hideThisOption ? [] : [{ value: "THIS" as EventEditType, label: "This event" }]),
		...(hideFollowingOption ? [] : [{ value: "FOLLOWING" as EventEditType, label: "This and following events" }]),
		{ value: "ALL", label: "All events" },
	];
	const result = await choiceModal({ choices, title: "Edit recurring event" });
	if (!result) {
		return null;
	}

	return result.value as EventEditType;
}
